import { styled } from '../jss-style';
import cardGroupStyle from './card-group';

const useCardGroupStyle = styled(cardGroupStyle, 'cardGroup');
export { cardGroupStyle, useCardGroupStyle };
export default useCardGroupStyle;
